/**
 * 增加千分数
 *
 * @param {number} num
 * @return {*}
 */
const percentile = (num = '') => {
  if (num) {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  else {
    return '0';
  }
};
export default percentile;
//# sourceMappingURL=percentile.js.map